"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Icon } from "@/components/ui/icon";
import { Label } from "@/components/ui/label";
import { useRouter, useSearchParams } from "next/navigation";
import { useState, useTransition } from "react";
import { AnimatedInput } from "../elements/form/animated-input";
export function QuoteSearchForm(t0) {
  const $ = _c(65);
  const {
    initialKeywords: t1,
    initialAuthor: t2,
    initialLengths: t3
  } = t0;
  const initialKeywords = t1 === undefined ? "" : t1;
  const initialAuthor = t2 === undefined ? "" : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const initialLengths = t4;
  const router = useRouter();
  const [keywords, setKeywords] = useState(initialKeywords);
  const [author, setAuthor] = useState(initialAuthor);
  let t5;
  if ($[2] !== initialLengths) {
    t5 = initialLengths || [];
    $[2] = initialLengths;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const [lengths, setLengths] = useState(t5);
  const [isPending, startTransition] = useTransition();
  const searchParams = useSearchParams();
  let t6;
  if ($[4] !== author || $[5] !== keywords || $[6] !== lengths || $[7] !== router || $[8] !== searchParams) {
    t6 = function handleSubmit(e) {
      e.preventDefault();
      const params = new URLSearchParams(searchParams);
      if (keywords && keywords.trim() !== "") {
        params.set("keywords", keywords.trim());
      }
      if (author && author.trim() !== "") {
        params.set("author", author.trim());
      }
      if (lengths && lengths.length > 0) {
        params.set("lengths", lengths.join(","));
      }
      startTransition(() => {
        router.replace(`/quotes/search?${params.toString()}`);
      });
    };
    $[4] = author;
    $[5] = keywords;
    $[6] = lengths;
    $[7] = router;
    $[8] = searchParams;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleSubmit = t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => {
      e_0.preventDefault();
      const {
        name,
        value
      } = e_0.target;
      if (name === "keywords") {
        setKeywords(value);
      } else {
        if (name === "author") {
          setAuthor(value);
        }
      }
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleChange = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = function handleCheckboxChange(value_0, checked) {
      if (checked) {
        setLengths(prev => [...prev, value_0]);
      } else {
        setLengths(prev_0 => prev_0.filter(item => item !== value_0));
      }
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const handleCheckboxChange = t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CardHeader><CardTitle className="flex items-center justify-end"><Icon icon="carbon:search" className="size-8" /></CardTitle></CardHeader>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== keywords) {
    t10 = <div className="space-y-2"><AnimatedInput name="keywords" label="Keywords" placeholder="Search for quotes containing keywords (eg. love, wisdom, etc.)" value={keywords} onChange={handleChange} type="text" /></div>;
    $[13] = keywords;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== author) {
    t11 = <div className="space-y-2"><AnimatedInput name="author" label="Author" placeholder="Search for quotes by a specific author" value={author} onChange={handleChange} type="text" /></div>;
    $[15] = author;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div><Label>Quote Length</Label><p className="text-sm text-muted-foreground">Filter quotes by their length</p></div>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== lengths) {
    t13 = lengths.includes("short");
    $[18] = lengths;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = checked_0 => handleCheckboxChange("short", checked_0);
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13) {
    t15 = <Checkbox id="short" name="lengths" value="short" checked={t13} onCheckedChange={t14} />;
    $[21] = t13;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Label htmlFor="short" className="font-normal">Short (1-75 characters)</Label>;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t15) {
    t17 = <div className="flex items-start space-x-3 space-y-0">{t15}{t16}</div>;
    $[24] = t15;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== lengths) {
    t18 = lengths.includes("medium");
    $[26] = lengths;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = checked_1 => handleCheckboxChange("medium", checked_1);
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t18) {
    t20 = <Checkbox id="medium" name="lengths" value="medium" checked={t18} onCheckedChange={t19} />;
    $[29] = t18;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Label htmlFor="medium" className="font-normal">Medium (76-150 characters)</Label>;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t20) {
    t22 = <div className="flex items-start space-x-3 space-y-0">{t20}{t21}</div>;
    $[32] = t20;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== lengths) {
    t23 = lengths.includes("long");
    $[34] = lengths;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = checked_2 => handleCheckboxChange("long", checked_2);
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t23) {
    t25 = <Checkbox id="long" name="lengths" value="long" checked={t23} onCheckedChange={t24} />;
    $[37] = t23;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Label htmlFor="long" className="font-normal">Long (150+ characters)</Label>;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== t25) {
    t27 = <div className="flex items-start space-x-3 space-y-0">{t25}{t26}</div>;
    $[40] = t25;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== t17 || $[43] !== t22 || $[44] !== t27) {
    t28 = <div className="space-y-4">{t12}<div className="flex flex-col space-y-2">{t17}{t22}{t27}</div></div>;
    $[42] = t17;
    $[43] = t22;
    $[44] = t27;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== isPending) {
    t29 = isPending ? <><Icon icon="mdi:loading" className="animate-spin" /><span>Searching...</span></> : "Search Quotes";
    $[46] = isPending;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== isPending || $[49] !== t29) {
    t30 = <Button type="submit" className="flex-1" disabled={isPending}>{t29}</Button>;
    $[48] = isPending;
    $[49] = t29;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== router) {
    t31 = () => {
      setKeywords("");
      setAuthor("");
      setLengths([]);
      startTransition(() => {
        router.replace("/quotes/search");
      });
    };
    $[51] = router;
    $[52] = t31;
  } else {
    t31 = $[52];
  }
  let t32;
  if ($[53] !== isPending || $[54] !== t31) {
    t32 = <Button type="reset" variant="secondary" className="flex-1" disabled={isPending} onClick={t31}>Reset</Button>;
    $[53] = isPending;
    $[54] = t31;
    $[55] = t32;
  } else {
    t32 = $[55];
  }
  let t33;
  if ($[56] !== t30 || $[57] !== t32) {
    t33 = <footer className="flex flex-col sm:flex-row md:flex-col 2xl:flex-row gap-2">{t30}{t32}</footer>;
    $[56] = t30;
    $[57] = t32;
    $[58] = t33;
  } else {
    t33 = $[58];
  }
  let t34;
  if ($[59] !== handleSubmit || $[60] !== t10 || $[61] !== t11 || $[62] !== t28 || $[63] !== t33) {
    t34 = <Card className="w-full">{t9}<CardContent><form onSubmit={handleSubmit} className="space-y-6">{t10}{t11}{t28}{t33}</form></CardContent></Card>;
    $[59] = handleSubmit;
    $[60] = t10;
    $[61] = t11;
    $[62] = t28;
    $[63] = t33;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  return t34;
}
export function QuoteSearchSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CardTitle className="text-2xl font-bold text-center">Search for Quotes</CardTitle>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Card className="w-full"><CardHeader>{t0}<CardContent><p className="animate-pulse">Loading...</p></CardContent></CardHeader></Card>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}